type IdTokenGroups = unknown;

const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every((item) => typeof item === 'string');

const extractGraphGroupIds = (graphGroups: unknown): string[] => {
  if (!Array.isArray(graphGroups)) {
    return [];
  }

  return graphGroups
    .map((group) => {
      if (typeof group === 'string') {
        return group;
      }

      if (group && typeof group === 'object' && 'id' in group) {
        const { id } = group as { id?: unknown };
        if (typeof id === 'string') {
          return id;
        }
      }

      return undefined;
    })
    .filter((id): id is string => Boolean(id));
};

export const getUserGroups = (
  idTokenGroups: IdTokenGroups,
  graphGroups: unknown
): string[] => {
  const claimGroups = isStringArray(idTokenGroups) ? idTokenGroups : [];
  const msGraphGroups = extractGraphGroupIds(graphGroups);
  return Array.from(new Set([...claimGroups, ...msGraphGroups]));
};
